export default function PHP_error_log() {
  return (
    <div>
      <h1>PHP_error_log</h1>
    </div>
  );
}
